import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell, Loading } from "./components.jsx";
import { useAuth } from "./auth.jsx";
import AuthPage from "./pages/AuthPage.jsx";
import DiaryPage from "./pages/DiaryPage.jsx";
import FeedPage from "./pages/FeedPage.jsx";
import ListPage from "./pages/ListPage.jsx";
import MoviePage from "./pages/MoviePage.jsx";
import OnboardingPage from "./pages/OnboardingPage.jsx";
import ProfilePage from "./pages/ProfilePage.jsx";
import SearchPage from "./pages/SearchPage.jsx";
import SettingsPage from "./pages/SettingsPage.jsx";

export default function App() {
  const { user, booting, logout } = useAuth();
  if (booting) return <div className="boot-screen"><Loading label="Preparando Rollo…" /></div>;
  if (!user) return <AuthPage />;
  if (!user.onboardingCompleted) return <OnboardingPage />;
  return <AppShell user={user} onLogout={logout}><Routes>
    <Route path="/" element={<FeedPage />} />
    <Route path="/buscar" element={<SearchPage />} />
    <Route path="/diario" element={<DiaryPage />} />
    <Route path="/perfil" element={<ProfilePage own />} />
    <Route path="/pelicula/:id" element={<MoviePage />} />
    <Route path="/lista/:id" element={<ListPage />} />
    <Route path="/ajustes" element={<SettingsPage />} />
    <Route path="/perfil/:username" element={<ProfilePage />} />
    <Route path="/@:username" element={<ProfilePage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></AppShell>;
}
